import React, { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ForcePasswordChange() {
  const { user, setUser } = useAuth();
  const [cur, setCur] = useState("");
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  if (!user || !user.force_password_reset) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (pw1.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw1 !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw1 });
      const me = (await api.get("/auth/me")).data;
      setUser(me);
      toast.success("Password updated. You can now use the platform.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to update password");
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-stone-900/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="force-pw-reset">
      <div className="bg-white max-w-md w-full rounded-xl shadow-2xl overflow-hidden">
        <div className="bg-[#0F2A4A] text-white p-5 flex items-center gap-3">
          <KeyRound className="w-5 h-5 text-[#72BE44]" />
          <div>
            <div className="text-[10px] uppercase tracking-wider text-[#72BE44] font-bold">First Login</div>
            <div className="font-bold">Set Your Password</div>
          </div>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          <p className="text-sm text-stone-600">For security, please change your initial password before continuing. Your login was created by the PT team.</p>
          <Field label="Current Password (initial)" type="password" value={cur} onChange={setCur} testid="fpr-current" />
          <Field label="New Password (min 6 chars)" type="password" value={pw1} onChange={setPw1} testid="fpr-new1" />
          <Field label="Confirm New Password" type="password" value={pw2} onChange={setPw2} testid="fpr-new2" />
          <button type="submit" disabled={loading} data-testid="fpr-submit"
            className="w-full bg-[#72BE44] text-white py-2.5 rounded-lg font-semibold disabled:opacity-50">
            {loading ? "Updating..." : "Set New Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <div>
      <label className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold">{label}</label>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} required data-testid={testid}
        className="mt-1 w-full px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg focus:bg-white focus:border-[#72BE44] focus:outline-none text-sm" />
    </div>
  );
}
